<template>
  <div class="ls-title-intro ls-no-padding-top ls-sm-margin-bottom ls-display-flex align-items-center flex-wrap">
    <div class="col-lg-6 col-xs-12">
      <h1 :class="'ls-no-margin-bottom ls-no-padding ls-title-intro breadcrumb-title ' + crumbs.ico">
        <div class="breadcrumb-content">
          <ol class="ls-breadcrumb">
            <li><router-link class="link" :to="{ path: '/' }">Início</router-link></li>
            <li v-for="crumb in crumbs.paths">
              <router-link class="link" v-if="crumb.path" :to="{ path: crumb.path }">{{ crumb.title }}</router-link>
              <span v-else>{{ crumb.title }}</span>
            </li>
          </ol>
          <span>{{crumbs.section}}</span>
        </div>
      </h1>
    </div>
    <div class="col-lg-6 col-xs-12 ls-sm-margin-top">
      <slot></slot>
    </div>
  </div>
</template>
<style lang="scss">
  .breadcrumb-title {
    display: flex;
    align-items: center;
  }
  .breadcrumb-content {
    display: flex;
    flex-wrap: wrap;
    white-space: normal;
    ol {
      width: 100%;
    }
    span {
      width: 100%;
    }
  }
  .ls-breadcrumb {
    border-bottom: 0!important;
    li:first-child {
      padding: 0;
    }
  }
  .align-items-center {
    align-items: center;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
</style>
<script>
  export default{
    props: ['crumbs'],
    name: 'Breadcrumb'
  }
</script>



// WEBPACK FOOTER //
// Breadcrumb.vue?a555786e